export default {
  divid_fund_name: 'Campaign name',
  divid_tokens_issued: 'Number of issued assets',
  divid_total_investments: 'Total investment',
  divid_total_payments: 'Total dividend payments',
  divid_payments_description: 'Enter the amount of dividend payments that will be distributed among investors',
  divid_investors_list: 'Investors list',
  divid_to_pay: 'Dividends to payable',
  divid_footer_description: 'Your project period ends in 15 days - after that you will have to pay all dividends to investors',
  divid_total_pay: 'Total amount of dividend payments',
  divid_your_balance: 'Your balance',
  divid_pay_btn: 'Pay dividends to investors',
  divid_accept_pay: 'Do you confirm the payment of dividends to investors?',
  divid_will_debited: 'We will charge <span style="color: #42A1F8">%{amount} %{currency}</span> from your account and make mass payment to investors',
  divid_can_search: 'You will be able to track the payment to each investor later in the “Transaction History” section',
  divid_success_title: 'Great, investors have received their dividends',
  divid_success_sub_title: 'Congrats on the successful project closure. We\'re glad that CryptoPort helped your with this — it\'s a win for us, too.',
  divid_success_text: 'You can confirm transactions to investors in the “Transaction History” section',
  divid_term_month: 'month',
  divid_tab_finish_title: 'The project is completed. Upload financial statement and pay dividends to investors',
  divid_tab_finish_text: ' to download the financial report',
  divid_ready_to_pay: 'Ready to pay dividends to investors?',
  divid_ready_to_pay_text: 'Your project period ends in 15 days - after that you will have to pay all dividends to investors',
  divid_save_report: 'Download the financial report here to add it to your project',
  divid_pay_error: 'Failed to pay dividends. Check the entered data or try again later',
  divid_pay_subject: 'Dividends from %{name} project'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/dividends_view.js